import React, { CSSProperties } from "react";
import classNames from "classnames";
import styles from "./Skeleton.module.scss";

interface Props {
    width?: number | string;
    height?: number | string;
    className?: string;
    animation?: "pulse" | "wave";
}

export const Skeleton: React.FC<Props> = ({
    width,
    height,
    className,
    animation = "pulse",
}) => {
    const style: CSSProperties = { width, height };

    return (
        <span
            className={classNames(
                styles.skeleton,
                animation === "wave" ? styles.wave : "animation-skeleton-pulse",
                className,
            )}
            style={style}
            aria-hidden="true"
        />
    );
};
